import { render } from "./discuss_packet_data.vue?vue&type=template&id=b8c57d24"
import script from "./discuss_packet_data.vue?vue&type=script&lang=js"
export * from "./discuss_packet_data.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__